export enum MaritalStatus {
    None = -1,
    Married = 1,
    Separated = 2,
    Unmarried = 3
}
